import React, { useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  Button,
  TimeSelector,
} from 'components';
import { ServiceService } from 'services';
import { CheckWhiteIcon, Calendar, ClockIcon } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
  title?: string;
  onClose?: any;
  item?: any;
  area_id: string;
}

const STEPS = {
  TIMES: 1,
  DAYS: 2,
};

const days = [
  { value: 0, label: 'Lunes' },
  { value: 1, label: 'Martes' },
  { value: 2, label: 'Miercoles' },
  { value: 3, label: 'Jueves' },
  { value: 4, label: 'Viernes' },
  { value: 5, label: 'Sábado' },
  { value: 6, label: 'Domingo' },
];

class CreateCallingService extends React.Component<Props> {
  state = {
    step: STEPS.TIMES,
    selectTimes: [],
    selectDays: [],
    item: null,
  };

  componentDidMount() {
    const { item } = this.props;
    this.load(item);
  }

  load = async (item: any) => {
    if (!item) return;

    const { hours } = item;
    const selectTimes = hours?.length > 0 ? JSON.parse(hours) : [];

    this.setState({
      selectTimes: selectTimes,
      item: item,
    });
  };

  isValid = (validDays: boolean) => {
    const { selectTimes, selectDays } = this.state;
    const { area_id } = this.props;
    if (selectTimes.length == 0) {
      Globals.showError('Seleccione al menos un horario');
      return false;
    }

    if (selectDays.length == 0 && validDays) {
      Globals.showError('Seleccione al menos un día');
      return false;
    }

    if (!area_id) {
      Globals.showError('Seleccione un área');
      return false;
    }

    return true;
  };

  next = () => {
    if (this.props.item) return;

    if (this.state.selectTimes.length == 0) {
      Globals.showError('Seleccione al menos un horario');
      return;
    }

    this.setState({
      step: this.state.step + 1,
    });
  };

  submit = async () => {
    const { item } = this.props;
    const validDays = item ? false : true;
    if (!this.isValid(validDays)) return;

    const { selectTimes, selectDays } = this.state;
    const { area_id, user } = this.props;
    const data: any = {
      user_id: user?.id,
      area_id: area_id,
      week_days: item && item.id === null ? [item.week_day] : selectDays,
      hours: JSON.stringify(selectTimes),
    };

    if (item && item.id !== null) {
      data.week_day = item.week_day;
      await ServiceService.calling.edit(data);
      Globals.showSuccess('Horario asignado correctamente');
      this.props.onClose();
      return;
    }

    await ServiceService.calling.create(data);
    Globals.showSuccess('Horario creado correctamente');
    this.props.onClose();
  };

  render() {
    const { step } = this.state;

    return (
      <div id="calling-services-create">
        {!this.props.item && (
          <div className="steps">
            <div className="step active">
              <img src={ClockIcon} alt="clock" className="active" />
              <span className="active">Horario</span>
            </div>
            <div className="line"></div>
            <div className={`step ${step == STEPS.DAYS ? 'active' : ''}`}>
              <img
                src={Calendar}
                alt="calendar"
                className={step == STEPS.DAYS ? 'active' : ''}
              />
              <span>Días</span>
            </div>
          </div>
        )}

        {step == STEPS.TIMES && (
          <>
            <div className="container-times">
              <TimeSelector
                selectedIntervals={this.state.selectTimes}
                onChange={(value) => {
                  this.setState({
                    selectTimes: value,
                  });
                }}
              />
            </div>

            {!this.props.item ? (
              <div className="col-md-12 text-center">
                <button onClick={this.next} className="btn">
                  Siguiente
                </button>
              </div>
            ) : (
              <div className="col-md-12 text-center">
                <button onClick={this.submit} className="btn">
                  Guardar
                </button>
              </div>
            )}
          </>
        )}

        {step == STEPS.DAYS && (
          <>
            <Days
              onChange={(value: any) => this.setState({ selectDays: value })}
            />

            <div className="col-md-12 text-center">
              <button onClick={this.submit} className="btn">
                Guardar
              </button>
            </div>
          </>
        )}
      </div>
    );
  }
}

const Days = ({ onChange }: any) => {
  const [selected, setSelected] = useState<Set<number>>(new Set());

  const onChangeDay = (value: number) => {
    const updated = new Set(selected);
    if (updated.has(value)) {
      updated.delete(value);
    } else {
      updated.add(value);
    }
    setSelected(updated);
    onChange(Array.from(updated));
  };

  return (
    <div className="container">
      <div className="row days-container">
        {days.map((item: any) => {
          return (
            <button
              key={item.value}
              className={`col-md-3 btn btn-day ${selected.has(item.value) ? 'active' : ''}`}
              onClick={() => onChangeDay(item.value)}
            >
              {item.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(CreateCallingService);
